module.exports = __webpack_public_path__ + "img/8af65bf0f67ce2ce2155e7a0f7e560a9.c0c1e281.png";